import { getIdentityKeyForIdentityInfo } from "owa-auth-types";
import { mutator } from "satcheljs";
import setAccountAuthState, { type SetAccountAuthStateActionMessage, } from "../actions/setAccountAuthState";
import getStore from "../store/Store";
import getAccountAuthState from "../selectors/getAccountAuthState";

/* eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Please use a mutatorAction if action is defined in the same package */
const defaultExport: (actionMessage: SetAccountAuthStateActionMessage) => void = mutator(setAccountAuthState, props => {
    const existingState = getAccountAuthState(props.identityInfo);
    if (!!existingState.isReplacedInSession) {
        // The account has been replaced in the session, so we must not update the state
        return;
    }
    
    const states = getStore().accountAuthStates;
    states.set(getIdentityKeyForIdentityInfo(props.identityInfo), props.authState);
});
export default defaultExport;
